export default "__VITE_ASSET__DqI_DOpU__"